export const MANY_COILS_VIEW = 'MANY_COILS_VIEW'

export const manyCoilsViewAction = value => dispatch => {
  dispatch({
    type: MANY_COILS_VIEW,
    payload: value,
  })
}
